export const editorTextModalName = 'editor-text-modal';
